"use client"
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Paper,
  Radio,
  TextField,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { Colors } from "../Theme/colors"
import { Fonts } from "../Theme/font"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export const PagesizeMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 112,
      padding: "16px 8px 16px 8px",
      alignItems: "flex-start",
      gap: 8,
      borderRadius: 8,
      border: `1px solid ${Colors.secondaryLight}`,
      boxShadow: "none",
    },
  },
}
export const FormTitle = styled(Box)({
  width: "100%",
  font: `normal 700 24px/24px ${Fonts.primary} `,
  color: Colors.dark,
  textAlign: "center",
  textTransform: "capitalize",
})
export const StyledMenuItem = styled(MenuItem)({
  font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
  color: Colors.dark,
  padding: "8px 16px",
  boxShadow: "none",
  "&:hover": {
    background: Colors.offwhite,
  },
  "&:focused": {
    background: Colors.offwhite,
    font: `normal normal 600 normal 16px/24px ${Fonts.primary}`,
  },
})

export const StyledSearchField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    width: "100%",
    height: 48,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
export const PagesizeSelectFormControl = styled(FormControl)({
  "& label": {
    font: `normal normal 400 normal 16px/30px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },

  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    paddingRight: 0,
    paddingTop: 3,
    gap: 0,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.light,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.light,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.light,
      borderWidth: 1,
    },
  },
  "& input:valid": {
    borderColor: Colors.buttonSuccess,
    borderWidth: 1,
  },
  "& input:invalid": {
    borderColor: Colors.buttonError,
    borderWidth: 1,
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
